// Debug logging for the watch-time feature. On in development builds (`npm start`), off in
// production builds unless REACT_APP_WATCH_DEBUG=true. Never logs tokens.
export const isWatchDebugEnabled = () =>
	process.env.NODE_ENV !== "production" ||
	process.env.REACT_APP_WATCH_DEBUG === "true";

export function watchLog(...args) {
	if (!isWatchDebugEnabled() || process.env.NODE_ENV === "test") return;
	// eslint-disable-next-line no-console
	console.log("[WATCH-TIME]", ...args);
}
